export default __webpack_public_path__ + "static/media/parth-tawde.b061e025.png";